import { serverTimestamp } from "firebase/firestore";
import { ObjectSchema } from "yup";
import schema from "@/schema";
import { getCurrentUser } from "@/services/auth";
import { TPerguntaForm, TPerguntaDatabaseFields, TPerguntaFormFields } from "../firestore";

const MIN_NAME_LENGTH = 3;

/**
 * Define only the meta fields that are not part of the form
 */
const perguntaSchemaDatabaseFields: ObjectSchema<TPerguntaDatabaseFields> = schema.object().shape({
  createdAt: schema
    .mixed<ReturnType<typeof serverTimestamp>>()
    .required()
    .defined()
    .nonNullable()
    .default<ReturnType<typeof serverTimestamp>>(() => serverTimestamp()),
  createdBy: schema
    .string()
    .required()
    .defined()
    .nonNullable()
    .default(() => {
      const currentUserId = getCurrentUser()?.uid;
      if (!currentUserId) {
        throw new Error("The current user is not defined");
      }
      return currentUserId;
    }),
  updatedAt: schema
    .mixed<ReturnType<typeof serverTimestamp>>()
    .default<ReturnType<typeof serverTimestamp>>(() => serverTimestamp()),
  updatedBy: schema.string().default(() => {
    const currentUserId = getCurrentUser()?.uid;
    if (!currentUserId) {
      throw new Error("The current user is not defined");
    }
    return currentUserId;
  }),
  deletedAt: schema.mixed<ReturnType<typeof serverTimestamp>>().defined().nullable().default(null)
});

/**
 * Define the schema for the form
 */
const perguntaSchemaFormFields: ObjectSchema<TPerguntaFormFields> = schema.object({
  id: schema.string().optional(),
  refPath: schema.string().optional(),
  nome: schema.string().min(MIN_NAME_LENGTH).required().defined().label("Nome"),
  grupo: schema.string().trim().required().defined().label("Grupo"),
  descricao: schema.string().trim().required().defined().label("Descrição"),
  tipoDeResposta: schema.string().trim().required().defined().label("Tipo de resposta"),
  ordem: schema.number().required().defined().label("Ordem"),
  obrigatoria: schema.boolean().required().defined().default(false).label("Obrigatória?"),
  inversa: schema.boolean().required().defined().default(false).label("Inversa?"),
  peso: schema.number().required().defined().label("Peso")
});

const perguntaSchema: ObjectSchema<TPerguntaForm> = perguntaSchemaFormFields
  // eslint-disable-next-line unicorn/prefer-spread
  .concat(perguntaSchemaDatabaseFields)
  .noUnknown()
  .strict()
  .label("Pergunta");

export default perguntaSchema;
